import { HEADER_DATA, MegaMenu } from '@nomadhealth/navigation-components';

import { useGlobalContext } from '@/hooks/use-global-context';

import { routes } from '@/utils/route-utils';

export const Navbar = () => {
  const { pageMeta } = useGlobalContext();

  const headerData = JSON.parse(JSON.stringify(HEADER_DATA));

  headerData.login.url = routes.signIn({ pathOnly: true });
  headerData.register.url = routes.register({ pathOnly: true });

  if (pageMeta.templateSetting) {
    if (headerData.logo && pageMeta.templateSetting.logoUrl) {
      headerData.logo.url = pageMeta.templateSetting.logoUrl;
    }

    if (pageMeta.templateSetting.isPPC) {
      delete headerData.nav;
      delete headerData.facilities;
    }
  }

  return (
    <header className='sticky z-[100]'>
      <MegaMenu {...headerData} />
    </header>
  );
};
